import { Body, Flex } from '@cognite/cogs.js';
import styled from 'styled-components/macro';

interface StepsForRevisionWarningProps {
  backgroundColor?: string;
}

export const ResolveActionTitle = styled(Body)`
  color: var(--cogs-decorative--red--500);
  padding-right: 8px;
`;

export const Container = styled(Flex)`
  padding: 12px;
  box-sizing: border-box;
  border-radius: 4px;
`;

export const StepsForRevisionWarning = styled(
  Container
)<StepsForRevisionWarningProps>`
  justify-content: space-between;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;
